module.exports = __webpack_public_path__ + "static/media/star.445d569a.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/star.png
// module id = 2910
// module chunks = 0